import { render, staticRenderFns } from "./FiltersNomenclature.vue?vue&type=template&id=4bd61db4&scoped=true&"
import script from "./FiltersNomenclature.vue?vue&type=script&lang=ts&"
export * from "./FiltersNomenclature.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersNomenclature.vue?vue&type=style&index=0&id=4bd61db4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd61db4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
